import React, { useEffect, useState } from 'react';
import { useLocaleContext } from '../../../context/LocaleContext';
import CWordCloud from '../../UI/CWordCloud';
import { throttle } from 'throttle-debounce';

export default ({ poll, fullPage, headerHidden }) => {
    const { getProperty } = useLocaleContext();

    const [words, setWords] = useState({});
    const [answerColors, setAnswerColors] = useState([]);

    const updateWords = throttle(2000, _words => setWords(_words.reduce((result, word) => ({ ...result, [getProperty(word, 'text')]: word.count }), {})));

    useEffect(() => {
        if (poll?.answer?.length) {
            updateWords(poll.answer);
        }
        if (poll?.options?.answerColors?.length) {
            setAnswerColors(poll.options.answerColors)
        }
    }, [poll]);

    const containerStyle = {
        height: fullPage ? '100%' : '20rem',
        backgroundImage: `url(${poll.backgroundImageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    }

    if (!poll) return null;

    return (
        <article className={'poll poll-open-result'}>
            {!headerHidden && <p className={"poll-text"}>{getProperty(poll, 'text')}</p>}
            <CWordCloud
                words={words}
                colors={answerColors}
                maxFontSize={fullPage ? 150 : 80}
                minFontSize={fullPage ? 15 : 12}
                style={containerStyle}
            />
        </article>
    );
};